import React from 'react';
import { useSelector } from 'react-redux';
import { PromotePayOnline } from './PromotePayOnline';
import { getCookie } from '../../utils/cookies';

type PaymentStatus = string;

interface PaymentMethod {
  name: string;
  status: PaymentStatus;
}

interface PaymentSettings {
  paymentMethods?: PaymentMethod[];
}

interface Merchant {
  paymentSettings?: PaymentSettings;
  whiteLabel?: string | null;
  createdAt: string; // ISO string
  currency?: string | null;
  subscriptionStatus?: string;
}

interface Account {
  isKeyAccount?: boolean | null;
}

const EUROPEAN_CURRENCIES = new Set(['EUR', 'GBP', 'CHF']);
const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

function isBannerVisible(): boolean {
  const showBannerCookie = getCookie('showPromotePayOnline');
  const showBannerCounter = Number(getCookie('showPromotePayOnlineCounter'));

  if (Number.isFinite(showBannerCounter) && showBannerCounter >= 6) {
    return false;
  }
  if (showBannerCookie !== null) {
    return showBannerCookie === 'true';
  }

  return true;
}

function isEligibleForPromotion(
  currentAccount: Account,
  currentMerchant: Merchant,
): boolean {
  const methods = currentMerchant.paymentSettings?.paymentMethods ?? [];

  const isPayOnlineActivated = methods.some(
    (m) => m?.name === 'shorepay_online' && m?.status === 'active',
  );

  const isWhitelabel =
    currentMerchant.whiteLabel !== null &&
    currentMerchant.whiteLabel !== 'shore';

  const isKeyAccount = Boolean(currentAccount?.isKeyAccount);

  const createdAtMs = Date.parse(currentMerchant.createdAt);
  const merchantHasMoreThan30Days =
    Number.isFinite(createdAtMs) && createdAtMs <= Date.now() - THIRTY_DAYS_MS;

  const currency = currentMerchant.currency?.toUpperCase();
  const isMerchantFromEurope = currency
    ? EUROPEAN_CURRENCIES.has(currency)
    : false;

  const hasPaidBookingPackage = currentMerchant.subscriptionStatus === 'active';

  return (
    !isPayOnlineActivated &&
    !isWhitelabel &&
    !isKeyAccount &&
    merchantHasMoreThan30Days &&
    isMerchantFromEurope &&
    hasPaidBookingPackage
  );
}

function shouldShowPromotePayOnline(
  currentAccount: Account,
  currentMerchant: Merchant,
): boolean {
  try {
    return (
      isBannerVisible() &&
      isEligibleForPromotion(currentAccount, currentMerchant)
    );
  } catch (error) {
    console.error(
      'Error in fetching data to show promote pay online banner:',
      error,
    );
    return false;
  }
}

export function Banners() {
  const currentAccount = useSelector((state: any) => state.currentAccount);
  const currentMerchant = useSelector((state: any) => state.currentMerchant);

  return (
    <div>
      {shouldShowPromotePayOnline(currentAccount, currentMerchant) && (
        <PromotePayOnline />
      )}
    </div>
  );
}
